// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__K_NwO","newExpiryDate":"styles_newExpiryDate__1XfV4","footer":"styles_footer__V-fWi"};